import { render } from "./filter-s5.vue?vue&type=template&id=c90af0b2"
import script from "./filter-s5.vue?vue&type=script&lang=js"
export * from "./filter-s5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__